import {
  ADMIN,
  ADMIN_USER,
  APPROVAL_LIST,
  CLIENT,
  CLIENTS_VIEWMORE_ACL,
  CLIENT_EDIT_ACL,
  DASHBOARD_APPROVAL_ACL,
  FINANCE,
  OPERATIONS,
  PREFUND_APPROVE_ACTION,
  RESELLER,
  RESELLER_VIEWMORE_ACL,
  RNC,
  RNC_APPROVE_ACTION,
  ROLE_ViewMore_ACL,
  SALES,
  SUPPORT
} from "./constants/valueConstants";

export const TransactionHeadersAdmin = [
  {
    title: "Date",
    key: "transaction_date"
  },
  {
    title: "Customer Name",
    key: "transactionClientName"
  },
  {
    title: "Customer UPI",
    key: "transactionClientUpi"
  },
  {
    title: "Customer UTR",
    key: "bankUTRNo"
  },
  {
    title: "Order ID",
    key: "orderId"
  },
  {
    title: "Txn ID",
    key: "transactionId"
  },
  {
    title: "Transaction Type",
    key: "service_type"
  },
  {
    title: "Amount",
    key: "txn_final_amount"
  },
  {
    title: "Status",
    key: "txnStatus"
  },
  {
    title: "Action",
    key: "action"
  }
];

export const TransactionHeaders = [
  {
    title: "Date",
    key: "modified_date"
  },
  {
    title: "Customer Name",
    key: "transactionClientName",
    roles: [ADMIN, ADMIN_USER, CLIENT, SALES, OPERATIONS, FINANCE, RNC, SUPPORT]
  },

  {
    title: "Client Name",
    key: "client_name",
    roles: [
      ADMIN,
      ADMIN_USER,
      RESELLER,
      SALES,
      OPERATIONS,
      FINANCE,
      RNC,
      SUPPORT
    ]
  },
  {
    title: "Customer UPI",
    key: "transactionClientPayinUpi",
    roles: [ADMIN, ADMIN_USER, CLIENT, SALES, RNC, OPERATIONS, FINANCE, SUPPORT]
  },
  {
    title: "Customer UTR",
    key: "bankUTRNo"
  },
  {
    title: "Order ID",
    key: "orderId"
  },
  {
    title: "Txn ID",
    key: "transactionId"
  },
  {
    title: "Transaction Type",
    key: "service_type"
  },
  {
    title: "Actual Amount  (RS)",
    key: "actual_amount",
    roles: [RESELLER]
  },
  {
    title: "Commission (RS)",
    key: "commissionAmount",
    roles: [RESELLER]
  },

  {
    title: "Commission Gst  (RS)",
    key: "commissionGst",
    roles: [RESELLER]
  },
  {
    title: "Amount  (RS)",
    key: "txn_final_amount"
  },

  {
    title: "Status",
    key: "txnStatus"
  },
  {
    title: "Action",
    key: "action",
    roles: [ADMIN, ADMIN_USER, CLIENT, SUPPORT, RNC, OPERATIONS, FINANCE]
  }
];

export const voucherTransactionHeaders = [
  {
    title: "Date",
    key: "modified_date"
  },
  {
    title: "Client Name",
    key: "client_name"
  },
  // {
  //   title: "Customer Name",
  //   key: "customerName",
  // },

  // {
  //   title: "Client Name",
  //   key: "client_name",
  //   roles: [RESELLER],
  // },
  {
    title: "Customer UPI",
    key: "transactionClientUpi"
    // roles: [
    //   ADMIN,
    //   ADMIN_USER,
    //   CLIENT,
    //   SALES,
    //   RNC,
    //   OPERATIONS,
    //   FINANCE,
    //   SUPPORT,
    // ],
  },
  {
    title: "Customer UTR",
    key: "bankUTRNo"
  },
  {
    title: "Order ID",
    key: "orderId"
  },
  {
    title: "Txn ID",
    key: "transactionId"
  },
  // {
  //   title: "Transaction Type",
  //   key: "service_type",
  // },
  {
    title: "Actual Amount  (RS)",
    key: "actual_amount",
    roles: [RESELLER]
  },
  {
    title: "Commission (RS)",
    key: "commissionAmount",
    roles: [RESELLER]
  },

  {
    title: "Commission Gst  (RS)",
    key: "commissionGst",
    roles: [RESELLER]
  },
  {
    title: "Actual Amount  (RS)",
    key: "actual_amount"
  },
  {
    title: "Amount  (RS)",
    key: "final_amount"
  },

  {
    title: "Status",
    key: "txnStatus"
  },
  {
    title: "Action",
    key: "action",
    roles: [ADMIN, ADMIN_USER, CLIENT, SUPPORT, RNC, OPERATIONS, FINANCE]
  }
];

export const PayoutTransactionHeaders = [
  {
    title: "Date",
    key: "modified_date"
  },
  {
    title: "Client Name",
    key: "client_name",
    roles: [
      ADMIN,
      ADMIN_USER,
      SALES,
      OPERATIONS,
      RNC,
      FINANCE,
      SUPPORT,
      RESELLER
    ]
  },
  {
    title: "Reseller Name",
    key: "reseller_name",
    roles: [ADMIN, ADMIN_USER, SALES, OPERATIONS, FINANCE, RNC, SUPPORT]
  },
  {
    title: "Bank UTR",
    key: "utr"
  },
  {
    title: "Txn ID",
    key: "payoutTransferId"
  },
  {
    title: "Bene Name",
    key: "beneName",
    roles: [ADMIN, ADMIN_USER, OPERATIONS, FINANCE, CLIENT, RNC, SUPPORT]
  },
  {
    title: "Transfer Mode",
    key: "transferMode"
  },
  {
    title: "Amount  (RS)",
    key: "txn_final_amount"
  },
  {
    title: "Status",
    key: "payoutStatus"
  },
  {
    title: "Action",
    key: "action",
    roles: [ADMIN, ADMIN_USER, CLIENT, SUPPORT, RNC, OPERATIONS, FINANCE]
  }
];
export const VanInternalTransactionHeaders = [
  {
    title: "Date",
    key: "transaction_date"
  },
  {
    title: "Client Name",
    key: "client_name",
    roles: [ADMIN, ADMIN_USER, SALES, OPERATIONS, FINANCE, SUPPORT, RESELLER]
  },
  {
    title: "Reseller Name",
    key: "reseller_name",
    roles: [ADMIN, ADMIN_USER, SALES, OPERATIONS, FINANCE, SUPPORT]
  },
  {
    title: "Bank UTR",
    key: "bankUtr"
  },
  {
    title: "Bene Account No",
    key: "bene_account_no"
  },
  {
    title: "Txn Type",
    key: "transfer_type"
  },
  {
    title: "Amount  (RS)",
    key: "txn_final_amount"
  },
  {
    title: "Status",
    key: "payoutStatus"
  },
  {
    title: "Action",
    key: "action",
    roles: [ADMIN, ADMIN_USER, CLIENT, SUPPORT, RNC]
  }
];

export const PrefundTransactionHeaders = [
  {
    title: "Date",
    key: "modified_date"
  },
  {
    title: "Client Name",
    key: "client_name",
    roles: [
      ADMIN,
      ADMIN_USER,
      CLIENT,
      SALES,
      OPERATIONS,
      FINANCE,
      SUPPORT,
      RESELLER,
      RNC
    ]
  },
  {
    title: "Reseller Name",
    key: "reseller_name",
    roles: [ADMIN, ADMIN_USER, CLIENT, SALES, OPERATIONS, RNC, FINANCE, SUPPORT]
  },
  {
    title: "Bank UTR",
    key: "utr"
  },
  {
    title: "Bene.Acc.No",
    key: "beneAccountNo"
  },
  {
    title: "Unique Number",
    key: "transferUniqueNo"
  },
  {
    title: "Transfer Type",
    key: "transferType"
  },

  {
    title: "Prefund Amount",
    key: "txn_final_amount"
  },
  {
    title: "Prefund Status",
    key: "txnStatus"
  },
  {
    title: "Action",
    key: "action",
    roles: [ADMIN, ADMIN_USER, CLIENT, SUPPORT, RNC, OPERATIONS, FINANCE]
  },
  {
    title: "Prefund Action",
    key: "prefundAction",
    acl: PREFUND_APPROVE_ACTION
  }
];

export const TransactionHeaderDashboard = [
  {
    title: "Date",
    key: "transaction_date"
  },
  {
    title: "Customer Name",
    key: "transactionClientName"
  },
  {
    title: "Customer UPI",
    key: "transactionClientUpi"
  },
  {
    title: "Customer UTR",
    key: "bankUTRNo"
  },
  {
    title: "Order ID",
    key: "orderId"
  },
  {
    title: "Txn ID",
    key: "transactionId"
  },
  {
    title: "Transaction Type",
    key: "service_type"
  },
  {
    title: "Amount",
    key: "txn_final_amount"
  },
  {
    title: "Status",
    key: "txnStatus"
  }
];

export const RecentTransactionHeaders = [
  {
    title: "Date",
    key: "createdDate"
  },
  {
    title: "Client name",
    key: "clientName"
  },
  {
    title: "Bank UTR",
    key: "sp_transaction_id"
  },
  {
    title: "Txn ID",
    key: "provider_transaction_id"
  },
  {
    title: "Txn Reference",
    key: "transaction_ref"
  },
  {
    title: "Transaction Type",
    key: "service_type"
  },
  {
    title: "Amount",
    key: "txn_final_amount"
  },
  {
    title: "Status",
    key: "txnStatus"
  }
];

export const ResellerHeaders = [
  {
    title: "Created At",
    key: "resellerUpdatedDate"
  },
  {
    title: "Name",
    key: "name"
  },
  {
    title: "Mobile Number",
    key: "mobileNumber"
  },
  {
    title: "Email ID",
    key: "email"
  },
  {
    title: "Created by",
    key: "createdBy"
  },
  {
    title: "Commission",
    key: "resellerCommissionRate"
  },
  {
    title: "Status",
    key: "toggleStatusReseller"
  },
  {
    title: "Action",
    key: "action",
    acl: RESELLER_VIEWMORE_ACL
  }
];

export const ResellerHeaders1 = [
  {
    title: "Created At",
    key: "resellerUpdatedDate"
  },
  {
    title: "Name",
    key: "name"
  },
  {
    title: "Mobile Number",
    key: "mobileNumber"
  },
  {
    title: "Email ID",
    key: "email"
  },
  {
    title: "Created by",
    key: "createdBy"
  },
  {
    title: "Commission",
    key: "resellerCommissionRate"
  },
  {
    title: "Status",
    key: "showStatus"
  }
];

export const ClientHeaders = [
  {
    title: "Sl.no",
    key: "slno"
  },
  {
    title: "Client Name",
    key: "name"
  },
  {
    title: "Company Name",
    key: "businessName"
  },
  {
    title: "Service Type",
    key: "serviceType"
  },
  {
    title: "Created date",
    key: "createdDate"
  },
  {
    title: "Commission",
    key: "comissionRate"
  },
  {
    title: "Status",
    key: "toggleStatus"
  },
  {
    title: "Action",
    key: "action"
  }
];

export const MainClientHeaders = [
  {
    title: "Approved By",
    key: "updatedAt",
    external: true
  },
  {
    title: "Client Name",
    key: "name",
    external: true
  },
  {
    title: "Company Name",
    key: "businessName",
    external: true
  },
  {
    title: "Reseller Name",
    key: "resellerName",
    external: false
  },
  {
    title: "Service Type",
    key: "serviceType",
    external: true
  },
  {
    title: "Service Provider name",
    key: "spName",
    external: false
  },
  {
    title: "Commission",
    key: "comissionRate",
    external: false
  },
  {
    title: "Status",
    key: "toggleStatus",
    external: true
  },
  {
    title: "Action",
    key: "action",
    external: true,
    acl: CLIENTS_VIEWMORE_ACL
  }
];

export const ChargeBackHeaders = [
  {
    title: "Sl.no",
    key: "slno"
  },
  {
    title: "Client Name",
    key: "name"
  },
  {
    title: "Business Name",
    key: "businessName"
  },
  {
    title: "Charge Back Hold",
    key: "chargeBackHold"
  },
  {
    title: "Charge Back Release",
    key: "chargeBackRelease"
  }
];
export const MainCustomerHeaders = [
  {
    title: "Sl.no",
    key: "slno"
  },
  {
    title: "Customer Name",
    key: "customerNameRisk"
  },
  {
    title: "Email",
    key: "email"
  },
  {
    title: "Mobile Number",
    key: "mobileNumberRisk"
  },
  {
    title: "UPI",
    key: "upi"
  },
  {
    title: "Status",
    key: "toggleStatusRisk"
  },
  {
    title: "Action",
    key: "action"
  }
];

export const PendingListHeaders = [
  {
    title: "Client Name",
    key: "name"
  },
  {
    title: "Business name",
    key: "businessName"
  },
  {
    title: "Reseller name",
    key: "resellerName"
  },
  {
    title: "Onboarded By",
    key: "createdBy"
  },
  {
    title: "Service Type",
    key: "serviceType"
  },
  { title: "Service Rate", key: "serviceRate" },
  { title: "SID", key: "kopay_cid" },
  {
    title: "Documents",
    key: "action",
    acl: APPROVAL_LIST
  },
  {
    title: "Action",
    key: "mainAction",
    acl: DASHBOARD_APPROVAL_ACL
  }
];
export const PendingListHeadersRnc = [
  {
    title: "Client Name",
    key: "name"
  },
  {
    title: "Business name",
    key: "businessName"
  },
  {
    title: "Reseller name",
    key: "resellerName"
  },
  {
    title: "Onboarded By",
    key: "createdBy"
  },
  {
    title: "Service Type",
    key: "serviceType"
  },
  { title: "Service Rate", key: "serviceRate" },

  {
    title: "Documents",
    key: "action",
    acl: APPROVAL_LIST
  },
  {
    title: "Action",
    key: "mainAction",
    acl: RNC_APPROVE_ACTION
  }
];

export const ApprovedListHeadersAdmin = [
  {
    title: "Onboarded Date",
    key: "updatedAt"
  },

  {
    title: "Client Name",
    key: "name"
  },
  {
    title: "Company Name",
    key: "businessName"
  },
  {
    title: "Reseller Name",
    key: "resellerName"
  },
  {
    title: "Onboarded By",
    key: "createdBy"
  },
  {
    title: "Service Type",
    key: "serviceType"
  },
  {
    title: "Client Rate",
    key: "clientRate"
  },
  {
    title: "Reseller Rate",
    key: "resellerRate"
  },
  {
    title: "Neokred Rate",
    key: "nkRate"
  },
  {
    title: "Documents",
    key: "action"
  }
];
export const ApprovedListHeadersRnc = [
  {
    title: "Approved Date",
    key: "updatedAtOnly"
  },

  {
    title: "Client Name",
    key: "name"
  },
  {
    title: "Business name ",
    key: "businessName"
  },
  {
    title: "Reseller Name",
    key: "resellerName"
  },
  {
    title: "Service Type",
    key: "serviceType"
  },
  { title: "Service Rate", key: "serviceRate" },
  {
    title: "Documents",
    key: "action",
    acl: APPROVAL_LIST
  }
];

export const RejectedListHeadersAdmin = [
  {
    title: "Rejected Date",
    key: "updatedAtOnly"
  },
  {
    title: "Business name ",
    key: "businessName"
  },
  {
    title: "Client Name",
    key: "name"
  },
  {
    title: "Reseller Name",
    key: "resellerName"
  },
  {
    title: "Onboarded By",
    key: "createdBy"
  },
  {
    title: "Service Type",
    key: "serviceType"
  },
  {
    title: "Client Rate",
    key: "clientRate"
  },
  {
    title: "Reseller Rate",
    key: "resellerRate"
  },
  {
    title: "Neokred Rate",
    key: "nkRate"
  },
  {
    title: "Rejected by",
    key: "rejectedDetails"
  },
  {
    title: "Documents",
    key: "action"
  }
];

export const RejectedListHeadersRnc = [
  {
    title: "Client Name",
    key: "name"
  },
  {
    title: "Business name ",
    key: "businessName"
  },
  {
    title: "Reseller Name",
    key: "resellerName"
  },
  {
    title: "Onboarded By",
    key: "createdBy"
  },
  {
    title: "Service Type",
    key: "serviceType"
  },
  { title: "Remark", key: "reason" },
  {
    title: "Documents",
    key: "action",
    acl: APPROVAL_LIST
  }
];

export const DeactivatedListHeaders = [
  {
    title: "Deactivated Date",
    key: "updatedAtOnly"
  },
  {
    title: "Business name ",
    key: "businessName"
  },
  {
    title: "Client Name",
    key: "name"
  },
  {
    title: "Reseller Name",
    key: "resellerName"
  },
  {
    title: "Onboarded By",
    key: "createdBy"
  },
  {
    title: "Service Type",
    key: "serviceType"
  },
  {
    title: "Client Rate",
    key: "clientRate"
  },
  {
    title: "Reseller Rate",
    key: "resellerRate"
  },
  {
    title: "Neokred Rate",
    key: "nkRate"
  },
  {
    title: "Deactivated by",
    key: "deactivatedDetails"
  },
  {
    title: "Documents",
    key: "action"
  }
];

export const SidList = [
  {
    title: "Client Name",
    key: "name"
  },
  {
    title: "Business name",
    key: "businessName"
  },
  {
    title: "Reseller name",
    key: "resellerName"
  },

  {
    title: "Service Type",
    key: "serviceType"
  },
  { title: "Service Rate", key: "serviceRate" },
  {
    title: "Enter SID",
    key: "SID"
  }
];

export const CommissionListHeaders = [
  {
    title: "Onboarded",
    key: "createdDate"
  },
  {
    title: "Client Name",
    key: "name"
  },
  {
    title: "Reseller Name",
    key: "resellerName"
  },
  {
    title: "SPR",
    key: "spr",
    tooltip: true,
    tooltipName: "Service provider rate"
  },
  {
    title: "NK rate",
    key: "nkRate"
  },
  {
    title: "Reseller rate",
    key: "resellerRate"
  },
  {
    title: "Total client rate",
    key: "clientRate"
  },
  // {
  //   title: "Revenue",
  //   key: "revenue",
  // },
  {
    title: "SPN",
    key: "spName",
    tooltip: true,
    tooltipName: "Service provider name"
  },
  {
    title: "Action",
    key: "commissionAction"
  }
];

export const UserListHeaders = [
  {
    title: "Sl.no",
    key: "slno"
  },
  {
    title: "Name",
    key: "name"
  },
  {
    title: "Email Id",
    key: "email"
  },
  {
    title: "Mobile Number",
    key: "mobileNumber"
  },
  {
    title: "Role",
    key: "role"
  },
  // {
  //   title: "Last active",
  //   key: "createdDate",
  // },
  {
    title: "Action",
    key: "userActions",
    acl: ROLE_ViewMore_ACL
  }
];

export const SettlementListHeaders = [
  {
    title: "Date",
    key: "settleMentCreatedAt"
  },
  {
    title: "From Date - To Date",
    key: "settlementStartAndEndDate"
  },
  {
    title: "Client name",
    key: "clientName"
  },
  {
    title: "Service Type",
    key: "financeServiceType"
  },
  {
    title: "Txn volume (RS)",
    key: "totalActualAmount"
  },
  {
    title: "Commission Amt(inc. GST)",
    key: "totalCommissionAmount"
  },
  {
    title: "Chargeback Hold",
    key: "chargeBack"
  },
  {
    title: "Chargeback Release",
    key: "chargeRelease"
  },
  // {
  //   title: "Commission Gst (RS)",
  //   key: "totalCommissionGst",
  // },
  {
    title: "Transfer amount (RS)",
    key: "totalTransferAmount"
  },
  {
    title: "NK Txn UTR",
    key: "txnId"
  },

  {
    title: "Bank UTR",
    key: "bankUtr"
  },
  {
    title: "Rolling Reserve",
    key: "rollingReserves"
  },
  {
    title: "Status",
    key: "settlementStatus"
  },
  {
    title: "Action",
    key: "approve"
  }
];

export const RevenueListHeaders = [
  {
    title: "Date",
    key: "revenueCreatedAt"
  },
  {
    title: "From Date - To Date",
    key: "revenueStartAndEndDate"
  },
  {
    title: "Client name",
    key: "clientName"
  },
  {
    title: "Reseller name",
    key: "resellerName"
  },
  {
    title: "Service Type",
    key: "financeServiceType"
  },
  {
    title: "Commission amount",
    key: "totalCommissionAmount"
  },
  {
    title: "Settlement Bank",
    key: "settlementBankName"
  },
  {
    title: "Settlement Account",
    key: "settlementAccount"
  },
  {
    title: "Transaction volume",
    key: "totalActualAmount"
  }
];
export const OnBoadingClientHeaders = [
  {
    title: "Sl.no",
    key: "slno"
  },
  {
    title: "Client name",
    key: "name"
  },
  {
    title: "Email Id",
    key: "email"
  },
  {
    title: "Mobile Number",
    key: "mobileNumber"
  },
  {
    title: "Comission",
    key: "comissionRate"
  },
  {
    title: "Created Date",
    key: "createdDate"
  },
  { title: "Status", key: "clientActiveStatus" }
];

export const VanFinanceHeaders = [
  {
    title: "From - To",
    key: ""
  },
  {
    title: "Business name",
    key: ""
  },
  {
    title: "NK UTR",
    key: ""
  },
  {
    title: "Txn ID",
    key: ""
  },
  {
    title: "Transfer amount",
    key: ""
  },
  {
    title: "Closing balance",
    key: ""
  },
  {
    title: "Status",
    key: ""
  },
  {
    title: "Action",
    key: "action"
  }
];

export const VanTransactionHeaders = [
  {
    title: "Date",
    key: "created_at",
    serviceProviderType: "all"
  },
  {
    title: "Business Name",
    key: "client_name",
    serviceProviderType: "all",
    roles: [
      ADMIN,
      ADMIN_USER,
      RNC,
      OPERATIONS,
      FINANCE,
      SUPPORT,
      RESELLER,
      SALES
    ]
  },
  {
    title: "Bank UTR",
    key: "bankUtr",
    serviceProviderType: "all"
  },
  {
    title: "bene_account_no",
    key: "bene_account_no",
    serviceProviderType: "van"
  },
  {
    title: "UPI",
    key: "van_upi_id",
    serviceProviderType: "van-upi"
  },
  {
    title: "Txn Type",
    key: "transfer_type",
    serviceProviderType: "van"
  },
  {
    title: "Amount",
    key: "van_actual_amount",
    serviceProviderType: "all"
  },
  {
    title: "Status",
    key: "txnStatus",
    serviceProviderType: "all"
  },
  {
    title: "Action",
    key: "action",
    serviceProviderType: "all",
    roles: [ADMIN, ADMIN_USER, CLIENT, RNC, OPERATIONS, FINANCE, SUPPORT]
  }
];

export const VanCustomerHeaders = [
  {
    title: "Date",
    key: "created_at",
    serviceProviderType: "all"
  },
  {
    title: "Customer Name",
    key: "vanCustomerName",
    serviceProviderType: "all",
    roles: [ADMIN, ADMIN_USER, RNC, OPERATIONS, FINANCE, SUPPORT, CLIENT]
  },
  {
    title: "VAN Created",
    key: "van_account_number",
    serviceProviderType: "van"
  },
  {
    title: "Upi",
    key: "upi",
    serviceProviderType: "van-upi"
  },
  {
    title: "Phone number",
    key: "mobile_number",
    serviceProviderType: "all",
    roles: [ADMIN, ADMIN_USER, RNC, OPERATIONS, SUPPORT, CLIENT]
  },
  {
    title: "PAN Number",
    key: "pan_number", //not present
    serviceProviderType: "van",
    roles: [ADMIN, ADMIN_USER, RNC, OPERATIONS, SUPPORT, CLIENT]
  },
  {
    title: "Status",
    key: "customerListStatus",
    serviceProviderType: "all"
  },
  {
    title: "Action",
    key: "action",
    serviceProviderType: "all",
    roles: [ADMIN, ADMIN_USER, CLIENT, RNC, OPERATIONS, SUPPORT]
  },
  {
    title: "Intent Create",
    key: "intent",
    serviceProviderType: "van-upi",
    roles: [CLIENT]
  }
];
export const VanTransactionHeader = [
  {
    title: "Date",
    key: "modified_date"
  },
  {
    title: "Business Name",
    key: "client_name",
    roles: [
      ADMIN,
      ADMIN_USER,
      RNC,
      OPERATIONS,
      FINANCE,
      SUPPORT,
      RESELLER,
      SALES
    ]
  },
  {
    title: "Bene Name",
    key: "bene_full_name",
    roles: [CLIENT]
  },
  {
    title: "Bank UTR",
    key: "bankUtr"
  },
  {
    title: "Bene_account_no",
    key: "bene_account_no"
  },
  {
    title: "Txn Type",
    key: "transfer_type"
  },
  {
    title: "Actual Amount",
    key: "actual_amount",
    roles: [RESELLER, FINANCE]
  },
  {
    title: "Commission",
    key: "commissionAmount",
    roles: [RESELLER, FINANCE]
  },
  {
    title: "Commission GST",
    key: "commissionGst",
    roles: [RESELLER, FINANCE]
  },
  {
    title: "Amount",
    key: "txn_final_amount"
  },
  {
    title: "Status",
    key: "txnStatus"
  },
  {
    title: "Action",
    key: "action",
    roles: [ADMIN, ADMIN_USER, CLIENT, RNC, OPERATIONS, FINANCE, SUPPORT]
  }
];

export const VanAllCustomerHeaders = [
  {
    title: "Date",
    key: "transaction_date"
  },
  {
    title: "Customer Name",
    key: "vanCustomerName",
    roles: [ADMIN, ADMIN_USER, CLIENT, RNC, OPERATIONS, FINANCE, SUPPORT]
  },
  {
    title: "Mobile Number",
    key: "customerMobileNumber",
    roles: [ADMIN, ADMIN_USER, CLIENT, RNC, OPERATIONS, SUPPORT]
  },
  {
    title: "VAN Account Number",
    key: "van_account_number"
  },
  {
    title: "VAN Account IFSC",
    key: "van_account_ifsc"
  },
  {
    title: "Email",
    key: "email",
    roles: [ADMIN, ADMIN_USER, CLIENT, RNC, OPERATIONS, SUPPORT]
  },
  {
    title: "Business name",
    key: "client_name",
    roles: [
      ADMIN,
      ADMIN_USER,
      RNC,
      OPERATIONS,
      FINANCE,
      SUPPORT,
      RESELLER,
      SALES
    ]
  },
  {
    title: "Status",
    key: "customerListStatus"
  },
  {
    title: "Action",
    key: "action",
    roles: [ADMIN, ADMIN_USER, CLIENT, RNC, OPERATIONS, SUPPORT]
  }
];

export const ActivityLogsHeaders = [
  {
    title: "Sl.no",
    key: "slno"
  },
  {
    title: "Time stamp",
    key: "timestamp"
  },
  {
    title: "Email",
    key: "email"
  },
  {
    title: "Mobile number",
    key: "mobileNumber"
  },
  {
    title: "Role",
    key: "role"
  },
  {
    title: "Action",
    key: "actionName"
  }
];

export const couponServiceHeaders = [
  {
    title: "Date",
    key: "transaction_date"
  },
  {
    title: "Customer Name",
    key: "vanCustomerName",
    roles: [ADMIN, ADMIN_USER, CLIENT, RNC, OPERATIONS, FINANCE, SUPPORT]
  },
  {
    title: "Mobile Number",
    key: "customerMobileNumber",
    roles: [ADMIN, ADMIN_USER, CLIENT, RNC, OPERATIONS, SUPPORT]
  },
  {
    title: "VAN Account Number",
    key: "van_account_number"
  },
  {
    title: "Email",
    key: "email",
    roles: [ADMIN, ADMIN_USER, CLIENT, RNC, OPERATIONS, SUPPORT]
  },
  {
    title: "Business name",
    key: "client_name",
    roles: [
      ADMIN,
      ADMIN_USER,
      RNC,
      OPERATIONS,
      FINANCE,
      SUPPORT,
      RESELLER,
      SALES
    ]
  },
  {
    title: "Status",
    key: "customerListStatus"
  },
  {
    title: "Action",
    key: "action",
    roles: [ADMIN, ADMIN_USER, CLIENT, RNC, OPERATIONS, SUPPORT]
  }
];
